import { NumericFormat, type NumberFormatValues } from 'react-number-format';
import { forwardRef, type KeyboardEvent } from 'react';

interface InputPriceProps {
    value: string | number;
    onValueChange?: (values: NumberFormatValues) => void;
    prefix: string;
    disabled?: boolean;
    allowNegative?: boolean;
    required?: boolean;
    className?: string;
    id?: string;
    autoFocus?: boolean;
    onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const InputPrice = forwardRef<HTMLInputElement, InputPriceProps>(
    (
        {
            value,
            onValueChange,
            prefix,
            disabled = false,
            allowNegative = false,
            required = false,
            className,
            id,
            autoFocus = false,
            onKeyDown,
        },
        ref,
    ) => {
        return (
            <NumericFormat
                id={id}
                autoFocus={autoFocus}
                getInputRef={(el: HTMLInputElement | null) => {
                    if (!ref) return;
                    if (typeof ref === 'function') {
                        ref(el);
                        return;
                    }
                    ref.current = el;
                }}
                className={['form-control', 'object-price', className].filter(Boolean).join(' ')}
                disabled={disabled}
                allowNegative={allowNegative}
                required={required}
                prefix={prefix}
                thousandSeparator=" "
                decimalSeparator="."
                allowedDecimalSeparators={['.', ',']}
                decimalScale={2}
                allowLeadingZeros
                value={value}
                onValueChange={onValueChange}
                onKeyDown={onKeyDown}
            />
        );
    },
);

InputPrice.displayName = 'InputPrice';

export default InputPrice;
